module.exports = __webpack_public_path__ + "img/2d.6fbbfda6.png";